import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

@Component({
  selector: "page-licencias",
  templateUrl: "licencias.html",
})
export class LicenciasPage {
  pestanya: string = "licencias";

  data: any = {};

  items: any = [];
  vacaciones = [];

  tiposlicencia = this.global.CONFIGURA["tipos_licencia"];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public global: GlobalProvider,
    public conector: ConectorProvider
  ) {
    this.data = {
      background: "assets/images/background/39.jpg",
    };

    this.tiposlicencia = this.global.CONFIGURA["tipos_licencia"];

    // console.log("tiposlicencias",this.global.CONFIGURA,this.global.CONFIGURA["tipos_licencia"])

    this.conector.getLicencias().subscribe((data) => {
      console.log("licencias", data);
      let licencias = data["licencias"];
      this.vacaciones = data["vacaciones"];

      licencias.forEach((lic) => {
        lic.tiponombre = this.tiposlicencia[lic.tipo];
      });
      this.items = licencias;
    });

    let TextLOG = "Acceso Lista de LICENCIAS ";

    this.conector.registraractividad(TextLOG).subscribe((data) => {
      console.log("registramos Actividad", TextLOG);
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad LicenciasPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/licencias/licencias.ts